/**
 * Construye la URL de WhatsApp (wa.me) para abrir la app o WhatsApp Web
 * con un mensaje pre-compuesto.
 *
 * Formato guardado por PhoneInput (Argentina):
 *   celular → "+549" + 10 dígitos (ej: "+5492975280428")
 *   fijo    → "+54"  + 10 dígitos
 * WhatsApp para Argentina necesita el 9: wa.me/549XXXXXXXXXX
 *
 * @param storedPhone  Número tal como lo almacena PhoneInput (ej: "+5492975280428")
 * @param message      Mensaje pre-compuesto en texto plano
 * @returns URL completa de wa.me o null si el número está vacío
 */
export function buildWhatsAppUrl(storedPhone: string | null | undefined, message: string): string | null {
  if (!storedPhone || storedPhone.trim() === '') return null;

  // Quitar el + y todos los espacios/guiones
  let digits = storedPhone.replace(/[^\d]/g, '');

  if (!digits) return null;

  // Argentina: WhatsApp exige el 9 después del código de país para celulares.
  //  - "549" + 10 dígitos (13) → ya es un celular canónico, se usa tal cual.
  //  - "54"  + 10 dígitos (12) → número sin el 9 (dato viejo / fijo): se asume celular
  //    e insertamos el 9 (los fijos no funcionan por WhatsApp de todos modos).
  if (digits.startsWith('549') && digits.length === 13) {
    // ya canónico, no tocar
  } else if (digits.startsWith('54') && !digits.startsWith('549') && digits.length === 12) {
    digits = '549' + digits.slice(2);
  }

  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${digits}?text=${encodedMessage}`;
}
